import { Injectable, EventEmitter } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';

interface Event {
    type: string;
    payload?: any;
}

type EventCallback = (payload: any) => void;

@Injectable({
    providedIn: 'root'
})

export class MenuEvent {
    private handler = new Subject<Event>();
    valor : string = '';
    modulo : string = '';
    switchMessageFormEvent = new EventEmitter<string>();
    switchMostrarModal = new EventEmitter<string>();
    switchAbrirModal = new EventEmitter<string>();
    constructor() { }

    /**
     * Broadcast the event
     * @param type type of event
     * @param payload payload
     */
    broadcast(type: string, payload = {}) {
        // console.log ('eventservice broadcast, type', type, ' payload=', payload);
        this.handler.next({ type, payload });       
    }

    /**
     * Subscribe to event
     * @param type type of event
     * @param callback call back function
     */
    subscribe(type: string, callback: EventCallback): Subscription {
        //console.log ('eventservice subscribe, type', type, ' callback=', callback);
        return this.handler.pipe(
            filter(event => event.type === type)).pipe(
                map(event => event.payload))
            .subscribe(callback);
    }

    unSubscribeAll () {
        this.handler.complete();
    }

    Listar() {
        this.handler.forEach(subs=>{
            console.log (subs.type); 
        });
    }    
    switchMessageForm(paremetro:string) {
        this.switchMessageFormEvent.emit(paremetro);
        this.peticion();
    }
    abrirmodalcompaniaysede(paremetro){
        this.switchAbrirModal.emit(paremetro);
    }
    peticion(){
        return 2;
    }

    // mospina 07-04-2026, Ajuste cambio de menu horizontal
    switchPerfilActivo = new Subject<any>();

    emitirCambioPerfil(modulo: any) {
    this.switchPerfilActivo.next(modulo);
    }
}
